import * as React from "react";
import { useMemo } from "react";
import { Formik } from "formik";
import { useParams } from "react-router-dom";
import useHistory from "routing/useHistory";
import Routes from "routing/Routes";
import { Wizard, Spinner } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import {
  useFetchLookupTable,
  useCreateLookupTable,
  useUpdateLookupTable
} from "components/lookup-tables/hooks/useLookupTablesAPI";
import useSteps from "components/lookup-tables/lookup-table-form/use-steps";
import WizardButtons from "./wizard-buttons";
export const INIT_TABLE_VALUES = {
  id: void 0,
  title: "",
  description: "",
  name: "",
  cache_id: void 0,
  data_adapter_id: void 0,
  enable_single_value: false,
  default_single_value: "",
  default_single_value_type: "NULL",
  enable_multi_value: false,
  default_multi_value: "",
  default_multi_value_type: "NULL",
  content_pack: null
};
const validations = (values) => {
  const errors = {};
  if (!values.title) errors.title = "Title is required";
  if (!values.name) errors.name = "Name is required";
  if (!values.cache_id) errors.cache_id = "Cache is required";
  if (!values.data_adapter_id) errors.data_adapter_id = "Data Adapter is required";
  return errors;
};
function LookupTableWizard() {
  const { lutIdOrName } = useParams();
  const { lookupTable, loadingLookupTable } = useFetchLookupTable(lutIdOrName);
  const initialValues = useMemo(() => lookupTable || INIT_TABLE_VALUES, [lookupTable]);
  const [steps, { activeStep, setActiveStep }] = useSteps();
  const { push } = useHistory();
  const sendTelemetry = useSendTelemetry("lookup_table");
  const { createLookupTable, creatingLookupTable } = useCreateLookupTable();
  const { updateLookupTable, updatingLookupTable } = useUpdateLookupTable();
  const isCreate = useMemo(() => !lookupTable, [lookupTable]);
  const handleStepChange = (newStepKey) => {
    setActiveStep(newStepKey);
  };
  const handleSubmit = async (values) => {
    const payload = { ...values };
    delete payload.enable_multi_value;
    delete payload.enable_single_value;
    const promise = isCreate ? createLookupTable(payload) : updateLookupTable(payload);
    return promise.then(() => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.LUT[isCreate ? "CREATED" : "UPDATED"], {
        app_pathname: "lut",
        event_details: {
          lookup_table_name: values.name
        }
      });
      push(Routes.SYSTEM.LOOKUPTABLES.OVERVIEW);
    });
  };
  if (loadingLookupTable) return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Lookup Table ..." });
  return /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: handleSubmit, validate: validations, validateOnMount: true }, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Wizard,
    {
      steps,
      activeStep,
      onStepChange: handleStepChange,
      horizontal: true,
      justified: true,
      containerClassName: "flex-row",
      hidePreviousNextButtons: true
    }
  ), /* @__PURE__ */ React.createElement(
    WizardButtons,
    {
      isCreate: !lookupTable,
      stepIds: steps.map((step) => step.key),
      activeStepId: activeStep,
      onStepChange: handleStepChange,
      isLoading: creatingLookupTable || updatingLookupTable
    }
  )));
}
export default LookupTableWizard;
